import { CordialEventType } from "@redotech/cockroachdb-codegen/congodb/cordial-event-type";
import { ReturnTrackingTriggerKey } from "@redotech/redo-flows-common/triggers";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const setCordialIntegration = {
  name: "setCordialIntegration" as const,
  input: z.object({
    apiKey: z.string().min(1, "API key is required"),
    apiBaseUrl: z.string().optional(),
    events: z.array(createEnum(CordialEventType)).optional(),
    returnTrackingTriggers: z
      .array(createEnum(ReturnTrackingTriggerKey))
      .optional(),
  }),
  output: z.object({}),
};

export type SetCordialIntegrationInput = z.infer<
  typeof setCordialIntegration.input
>;

export const updateCordialIntegration = {
  name: "updateCordialIntegration" as const,
  input: z.object({
    events: z.array(createEnum(CordialEventType)).optional(),
    returnTrackingTriggers: z
      .array(createEnum(ReturnTrackingTriggerKey))
      .optional(),
  }),
  output: z.object({}),
};

export type UpdateCordialIntegrationInput = z.infer<
  typeof updateCordialIntegration.input
>;

export const getCordialIntegration = {
  name: "getCordialIntegration" as const,
  input: z.object({}),
  output: z.object({
    cordialIntegration: z.optional(
      z.object({
        events: z.array(createEnum(CordialEventType)),
        returnTrackingTriggers: z.array(createEnum(ReturnTrackingTriggerKey)),
        apiBaseUrl: z.string().optional(),
      }),
    ),
  }),
};

export type GetCordialIntegrationOutput = z.infer<
  typeof getCordialIntegration.output
>;

export const disconnectCordialIntegration = {
  name: "disconnectCordialIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
